import { observer } from 'mobx-react'
import EnekaLogo from './assets/images/eneka.svg'

const Fallback = observer(() => {
  return (
    <div className="animate-pulse flex items-center justify-center h-full w-full">
      <img className="fallback-logo" src={EnekaLogo} alt="" />
    </div>
  )
})

export default Fallback
